// A folder that opens faster than this never flashes a loading overlay.
export const FOLDER_LOADER_DELAY_MS = 1000
